var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('floating-window',{attrs:{"name":"Video"}},[_c('div'),_vm._v(" "),_c('el-tabs',[_c('el-tab-pane',{attrs:{"label":"video"}},[_c('video-controller')],1),_vm._v(" "),_c('el-tab-pane',{attrs:{"label":"youtube"}},[_c('youtube-controller')],1),_vm._v(" "),_c('el-tab-pane',{attrs:{"label":"stream"}},[_c('stream-controller')],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0540124e","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/video/controller/index.vue
// module id = null
// module chunks = 